// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fill the card to the same height as a room screen and center the content
   in it, so landing -> room doesn't change the card's footprint. */
.landing {
  position: relative;
  box-sizing: border-box;
  min-height: var(--content-height);
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 2.25rem 3rem 3rem;
  text-align: center;
  overflow: hidden;
  background:
    radial-gradient(ellipse 55% 42% at 12% -8%, rgba(240, 110, 163, 0.22), transparent 70%),
    radial-gradient(ellipse 50% 40% at 92% 0%, rgba(56, 182, 245, 0.28), transparent 68%);
}

.landingHero,
.landingActions {
  position: relative;
  z-index: 1;
}

.landingHero {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1.6rem;
  animation: landIn 0.7s var(--bounce-effect) both;
}

.landingLogoWrap {
  position: relative;
  display: grid;
  place-items: center;
  margin: 0.15rem 0 0.35rem;
}

.landingLogoWrap::before {
  content: "";
  position: absolute;
  width: 11rem;
  height: 11rem;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.95) 0%,
    rgba(180, 227, 251, 0.55) 38%,
    rgba(246, 179, 205, 0.22) 58%,
    transparent 72%
  );
  animation: glowPulse 3.4s ease-in-out infinite;
}

.landingHero .logo {
  position: relative;
  height: 7.25rem;
  width: auto;
  margin: 0.5rem 0 0.35rem;
  filter: drop-shadow(0 8px 14px rgba(14, 36, 99, 0.28));
  animation: iceBob 3.6s ease-in-out infinite;
}

.landingHero h1 {
  position: relative;
  display: flex;
  justify-content: center;
  font-size: 3.15rem;
  margin: 0.15rem 0 0;
  letter-spacing: -0.02em;
  animation: landIn 0.7s var(--bounce-effect) 0.06s both;
}

.landingHero h1::after {
  content: "";
  position: absolute;
  left: 50%;
  bottom: -0.35rem;
  width: 4.6rem;
  height: 5px;
  margin-left: -2.3rem;
  border-radius: var(--pill-radius);
  background: linear-gradient(90deg, var(--pink), var(--blue));
}

.landingHero .ice {
  color: var(--pink);
}

.landingHero .breaker {
  color: var(--navy);
}

.landingTagline {
  max-width: 34rem;
  margin: 1.05rem auto 0;
  font-size: 1.1rem;
  line-height: 1.5;
  color: var(--ink-soft);
  animation: landIn 0.7s var(--bounce-effect) 0.12s both;
}

.landingRounds {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.45rem;
  list-style: none;
  margin: 1.15rem 0 0;
  padding: 0;
  max-width: 36rem;
}

.landingRounds li {
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 0.92rem;
  line-height: 1.2;
  padding: 0.38rem 0.85rem;
  border-radius: var(--pill-radius);
  color: var(--ink);
  box-shadow: 0 2px 0 rgba(14, 36, 99, 0.12);
  animation: chipIn 0.65s var(--bounce-effect) both;
}

.landingRounds li[data-format="multiple_choice"] {
  background: var(--sky);
  --tilt: -2.5deg;
  animation-delay: 0.22s;
}

.landingRounds li[data-format="free_input"] {
  background: var(--pink-soft);
  --tilt: 2.2deg;
  animation-delay: 0.28s;
}

.landingRounds li[data-format="slider"] {
  background: var(--sky-strong);
  --tilt: -1.8deg;
  animation-delay: 0.34s;
}

.landingRounds li[data-format="drawing"] {
  background: linear-gradient(135deg, var(--sky) 0%, var(--pink-soft) 100%);
  --tilt: 2.6deg;
  animation-delay: 0.4s;
}

.landingActions {
  background: var(--white);
  border-radius: var(--card-radius);
  box-shadow: var(--shadow-card), 0 10px 28px rgba(14, 36, 99, 0.08);
  padding: 1.75rem 2rem 1.5rem;
  margin: 0 auto;
  width: 100%;
  max-width: 30rem;
  box-sizing: border-box;
  animation: landIn 0.75s var(--bounce-effect) 0.18s both;
}

.landingActions button.block {
  margin-top: 0;
}

.landingDivider {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin: 1.25rem 0 1rem;
  color: var(--ink-soft);
  font-size: 0.95rem;
}

.landingDivider::before,
.landingDivider::after {
  content: "";
  flex: 1;
  height: 1px;
  background: var(--ink-faint);
}

.joinRow {
  display: flex;
  gap: 0.5rem;
}

.joinRow input {
  flex: 1;
  min-width: 0;
  margin: 0;
  text-transform: uppercase;
  text-align: center;
  letter-spacing: 0.15em;
  font-family: var(--font-heading);
  font-weight: 600;
}

.joinRow input::placeholder {
  text-transform: none;
  letter-spacing: normal;
  font-family: var(--font-body);
}

.joinRow button {
  margin: 0;
}

/* Sparkle / flake layout for this screen (shapes live in sparkles.css). */
.landingDecor .spark.s1 { top: 5%; left: 8%; animation-delay: 0s; background: var(--pink); }
.landingDecor .spark.s2 { top: 9%; right: 10%; width: 0.8rem; height: 0.8rem; animation-delay: 0.4s; background: var(--blue); }
.landingDecor .spark.s3 { top: 38%; left: 14%; width: 0.7rem; height: 0.7rem; animation-delay: 0.9s; }
.landingDecor .spark.s4 { top: 36%; right: 16%; animation-delay: 1.3s; background: var(--pink); }
.landingDecor .spark.s5 { bottom: 16%; left: 6%; width: 0.65rem; height: 0.65rem; animation-delay: 0.6s; background: var(--blue); }
.landingDecor .spark.s6 { bottom: 18%; right: 7%; width: 0.85rem; height: 0.85rem; animation-delay: 1.6s; }

.landingDecor .flake.f1 { top: 18%; left: 22%; background: var(--pink-soft); animation-delay: 0.2s; }
.landingDecor .flake.f2 { top: 6%; right: 24%; animation-delay: 1.1s; }
.landingDecor .flake.f3 { top: 46%; left: 6%; background: var(--blue); animation-delay: 2s; }
.landingDecor .flake.f4 { top: 44%; right: 8%; background: var(--pink); animation-delay: 2.8s; }

/* ---- Leaving for a new room: the ice cracks and the pink/blue split
   closes over the card. The room screen then opens it back up. ---- */

.landing.leaving {
  pointer-events: none;
}

.landing.leaving .landingHero,
.landing.leaving .landingActions {
  animation: landOut 0.4s ease-in both;
}

.landing.leaving .landingActions {
  animation-delay: 0.05s;
}

.landing.leaving .landingHero .logo {
  animation: iceCrack 0.45s ease-in-out both;
}

.landing.leaving .landingDecor {
  animation: fadeOut 0.3s ease-out both;
}

@keyframes landOut {
  to {
    opacity: 0;
    transform: translateY(-14px) scale(0.94);
  }
}

@keyframes iceCrack {
  0% { transform: translateY(0) rotate(-2.4deg); }
  20% { transform: translateY(-2px) rotate(3deg) scale(1.04); }
  40% { transform: translateY(1px) rotate(-4deg) scale(1.06); }
  60% { transform: translateY(-1px) rotate(3.5deg) scale(1.05); }
  80% { transform: translateY(1px) rotate(-2deg) scale(1.02); }
  100% { transform: translateY(0) rotate(0deg) scale(0.9); opacity: 0; }
}

@keyframes fadeOut {
  to { opacity: 0; }
}

@keyframes chipIn {
  from {
    opacity: 0;
    transform: translateY(10px) rotate(0deg) scale(0.88);
  }
  to {
    opacity: 1;
    transform: translateY(0) rotate(var(--tilt, 0deg)) scale(1);
  }
}

@keyframes iceBob {
  0%, 100% { transform: translateY(0) rotate(-2.4deg); }
  50% { transform: translateY(-9px) rotate(2.4deg); }
}

@keyframes glowPulse {
  0%, 100% { transform: scale(1); opacity: 0.85; }
  50% { transform: scale(1.12); opacity: 1; }
}

@media (max-width: 600px) {
  .landing {
    min-height: calc(100dvh - 3.6rem);
    padding: 1.5rem 1.25rem 2rem;
  }

  .landingHero .logo {
    height: 6.2rem;
  }

  .landingHero h1 {
    font-size: 2.45rem;
  }

  .landingLogoWrap::before {
    width: 9rem;
    height: 9rem;
  }

  .landingRounds {
    display: grid;
    grid-template-columns: auto auto;
    justify-content: center;
  }

  .landingActions {
    padding: 1.25rem;
  }

  .landingDecor .spark.s3,
  .landingDecor .spark.s5,
  .landingDecor .flake.f3 {
    display: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .landingHero,
  .landingHero h1,
  .landingTagline,
  .landingRounds li,
  .landingActions,
  .landingHero .logo,
  .landingLogoWrap::before,
  .landing.leaving .landingHero,
  .landing.leaving .landingActions,
  .landing.leaving .landingHero .logo,
  .landing.leaving .landingDecor {
    animation: none;
  }

  .landingRounds li {
    transform: rotate(var(--tilt, 0deg));
  }

  .landing.leaving .landingHero,
  .landing.leaving .landingActions {
    opacity: 0.4;
    transition: opacity 0.2s;
  }
}
`, "",{"version":3,"sources":["webpack://./src/browser/webapp/components/landing.css"],"names":[],"mappings":"AAAA;mEACmE;AACnE;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB;;yFAEuF;AACzF;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB;;;;;;GAMC;EACD,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,wBAAwB;EACxB,sDAAsD;EACtD,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,sDAAsD;AACxD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,iCAAiC;EACjC,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,iCAAiC;EACjC,iBAAiB;EACjB,0CAA0C;EAC1C,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yEAAyE;EACzE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,kEAAkE;EAClE,4BAA4B;EAC5B,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,uDAAuD;AACzD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,OAAO;EACP,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,sBAAsB;EACtB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,SAAS;AACX;;AAEA,0EAA0E;AAC1E,0BAA0B,OAAO,EAAE,QAAQ,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;AAC3F,0BAA0B,OAAO,EAAE,UAAU,EAAE,aAAa,EAAE,cAAc,EAAE,qBAAqB,EAAE,uBAAuB,EAAE;AAC9H,0BAA0B,QAAQ,EAAE,SAAS,EAAE,aAAa,EAAE,cAAc,EAAE,qBAAqB,EAAE;AACrG,0BAA0B,QAAQ,EAAE,UAAU,EAAE,qBAAqB,EAAE,uBAAuB,EAAE;AAChG,0BAA0B,WAAW,EAAE,QAAQ,EAAE,cAAc,EAAE,eAAe,EAAE,qBAAqB,EAAE,uBAAuB,EAAE;AAClI,0BAA0B,WAAW,EAAE,SAAS,EAAE,cAAc,EAAE,eAAe,EAAE,qBAAqB,EAAE;;AAE1G,0BAA0B,QAAQ,EAAE,SAAS,EAAE,4BAA4B,EAAE,qBAAqB,EAAE;AACpG,0BAA0B,OAAO,EAAE,UAAU,EAAE,qBAAqB,EAAE;AACtE,0BAA0B,QAAQ,EAAE,QAAQ,EAAE,uBAAuB,EAAE,mBAAmB,EAAE;AAC5F,0BAA0B,QAAQ,EAAE,SAAS,EAAE,uBAAuB,EAAE,qBAAqB,EAAE;;AAE/F;sEACsE;;AAEtE;EACE,oBAAoB;AACtB;;AAEA;;EAEE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;AACF;;AAEA;EACE,KAAK,wCAAwC,EAAE;EAC/C,MAAM,oDAAoD,EAAE;EAC5D,MAAM,oDAAoD,EAAE;EAC5D,MAAM,sDAAsD,EAAE;EAC9D,MAAM,oDAAoD,EAAE;EAC5D,OAAO,gDAAgD,EAAE,UAAU,EAAE;AACvE;;AAEA;EACE,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE;IACE,UAAU;IACV,oDAAoD;EACtD;EACA;IACE,UAAU;IACV,2DAA2D;EAC7D;AACF;;AAEA;EACE,WAAW,wCAAwC,EAAE;EACrD,MAAM,0CAA0C,EAAE;AACpD;;AAEA;EACE,WAAW,mBAAmB,EAAE,aAAa,EAAE;EAC/C,MAAM,sBAAsB,EAAE,UAAU,EAAE;AAC5C;;AAEA;EACE;IACE,iCAAiC;IACjC,4BAA4B;EAC9B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;IACb,gCAAgC;IAChC,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;IAGE,aAAa;EACf;AACF;;AAEA;EACE;;;;;;;;;;;IAWE,eAAe;EACjB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;;IAEE,YAAY;IACZ,wBAAwB;EAC1B;AACF","sourcesContent":["/* Fill the card to the same height as a room screen and center the content\n   in it, so landing -> room doesn't change the card's footprint. */\n.landing {\n  position: relative;\n  box-sizing: border-box;\n  min-height: var(--content-height);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 2.25rem 3rem 3rem;\n  text-align: center;\n  overflow: hidden;\n  background:\n    radial-gradient(ellipse 55% 42% at 12% -8%, rgba(240, 110, 163, 0.22), transparent 70%),\n    radial-gradient(ellipse 50% 40% at 92% 0%, rgba(56, 182, 245, 0.28), transparent 68%);\n}\n\n.landingHero,\n.landingActions {\n  position: relative;\n  z-index: 1;\n}\n\n.landingHero {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 1.6rem;\n  animation: landIn 0.7s var(--bounce-effect) both;\n}\n\n.landingLogoWrap {\n  position: relative;\n  display: grid;\n  place-items: center;\n  margin: 0.15rem 0 0.35rem;\n}\n\n.landingLogoWrap::before {\n  content: \"\";\n  position: absolute;\n  width: 11rem;\n  height: 11rem;\n  border-radius: 50%;\n  background: radial-gradient(\n    circle,\n    rgba(255, 255, 255, 0.95) 0%,\n    rgba(180, 227, 251, 0.55) 38%,\n    rgba(246, 179, 205, 0.22) 58%,\n    transparent 72%\n  );\n  animation: glowPulse 3.4s ease-in-out infinite;\n}\n\n.landingHero .logo {\n  position: relative;\n  height: 7.25rem;\n  width: auto;\n  margin: 0.5rem 0 0.35rem;\n  filter: drop-shadow(0 8px 14px rgba(14, 36, 99, 0.28));\n  animation: iceBob 3.6s ease-in-out infinite;\n}\n\n.landingHero h1 {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  font-size: 3.15rem;\n  margin: 0.15rem 0 0;\n  letter-spacing: -0.02em;\n  animation: landIn 0.7s var(--bounce-effect) 0.06s both;\n}\n\n.landingHero h1::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  bottom: -0.35rem;\n  width: 4.6rem;\n  height: 5px;\n  margin-left: -2.3rem;\n  border-radius: var(--pill-radius);\n  background: linear-gradient(90deg, var(--pink), var(--blue));\n}\n\n.landingHero .ice {\n  color: var(--pink);\n}\n\n.landingHero .breaker {\n  color: var(--navy);\n}\n\n.landingTagline {\n  max-width: 34rem;\n  margin: 1.05rem auto 0;\n  font-size: 1.1rem;\n  line-height: 1.5;\n  color: var(--ink-soft);\n  animation: landIn 0.7s var(--bounce-effect) 0.12s both;\n}\n\n.landingRounds {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 0.45rem;\n  list-style: none;\n  margin: 1.15rem 0 0;\n  padding: 0;\n  max-width: 36rem;\n}\n\n.landingRounds li {\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 0.92rem;\n  line-height: 1.2;\n  padding: 0.38rem 0.85rem;\n  border-radius: var(--pill-radius);\n  color: var(--ink);\n  box-shadow: 0 2px 0 rgba(14, 36, 99, 0.12);\n  animation: chipIn 0.65s var(--bounce-effect) both;\n}\n\n.landingRounds li[data-format=\"multiple_choice\"] {\n  background: var(--sky);\n  --tilt: -2.5deg;\n  animation-delay: 0.22s;\n}\n\n.landingRounds li[data-format=\"free_input\"] {\n  background: var(--pink-soft);\n  --tilt: 2.2deg;\n  animation-delay: 0.28s;\n}\n\n.landingRounds li[data-format=\"slider\"] {\n  background: var(--sky-strong);\n  --tilt: -1.8deg;\n  animation-delay: 0.34s;\n}\n\n.landingRounds li[data-format=\"drawing\"] {\n  background: linear-gradient(135deg, var(--sky) 0%, var(--pink-soft) 100%);\n  --tilt: 2.6deg;\n  animation-delay: 0.4s;\n}\n\n.landingActions {\n  background: var(--white);\n  border-radius: var(--card-radius);\n  box-shadow: var(--shadow-card), 0 10px 28px rgba(14, 36, 99, 0.08);\n  padding: 1.75rem 2rem 1.5rem;\n  margin: 0 auto;\n  width: 100%;\n  max-width: 30rem;\n  box-sizing: border-box;\n  animation: landIn 0.75s var(--bounce-effect) 0.18s both;\n}\n\n.landingActions button.block {\n  margin-top: 0;\n}\n\n.landingDivider {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin: 1.25rem 0 1rem;\n  color: var(--ink-soft);\n  font-size: 0.95rem;\n}\n\n.landingDivider::before,\n.landingDivider::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background: var(--ink-faint);\n}\n\n.joinRow {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.joinRow input {\n  flex: 1;\n  min-width: 0;\n  margin: 0;\n  text-transform: uppercase;\n  text-align: center;\n  letter-spacing: 0.15em;\n  font-family: var(--font-heading);\n  font-weight: 600;\n}\n\n.joinRow input::placeholder {\n  text-transform: none;\n  letter-spacing: normal;\n  font-family: var(--font-body);\n}\n\n.joinRow button {\n  margin: 0;\n}\n\n/* Sparkle / flake layout for this screen (shapes live in sparkles.css). */\n.landingDecor .spark.s1 { top: 5%; left: 8%; animation-delay: 0s; background: var(--pink); }\n.landingDecor .spark.s2 { top: 9%; right: 10%; width: 0.8rem; height: 0.8rem; animation-delay: 0.4s; background: var(--blue); }\n.landingDecor .spark.s3 { top: 38%; left: 14%; width: 0.7rem; height: 0.7rem; animation-delay: 0.9s; }\n.landingDecor .spark.s4 { top: 36%; right: 16%; animation-delay: 1.3s; background: var(--pink); }\n.landingDecor .spark.s5 { bottom: 16%; left: 6%; width: 0.65rem; height: 0.65rem; animation-delay: 0.6s; background: var(--blue); }\n.landingDecor .spark.s6 { bottom: 18%; right: 7%; width: 0.85rem; height: 0.85rem; animation-delay: 1.6s; }\n\n.landingDecor .flake.f1 { top: 18%; left: 22%; background: var(--pink-soft); animation-delay: 0.2s; }\n.landingDecor .flake.f2 { top: 6%; right: 24%; animation-delay: 1.1s; }\n.landingDecor .flake.f3 { top: 46%; left: 6%; background: var(--blue); animation-delay: 2s; }\n.landingDecor .flake.f4 { top: 44%; right: 8%; background: var(--pink); animation-delay: 2.8s; }\n\n/* ---- Leaving for a new room: the ice cracks and the pink/blue split\n   closes over the card. The room screen then opens it back up. ---- */\n\n.landing.leaving {\n  pointer-events: none;\n}\n\n.landing.leaving .landingHero,\n.landing.leaving .landingActions {\n  animation: landOut 0.4s ease-in both;\n}\n\n.landing.leaving .landingActions {\n  animation-delay: 0.05s;\n}\n\n.landing.leaving .landingHero .logo {\n  animation: iceCrack 0.45s ease-in-out both;\n}\n\n.landing.leaving .landingDecor {\n  animation: fadeOut 0.3s ease-out both;\n}\n\n@keyframes landOut {\n  to {\n    opacity: 0;\n    transform: translateY(-14px) scale(0.94);\n  }\n}\n\n@keyframes iceCrack {\n  0% { transform: translateY(0) rotate(-2.4deg); }\n  20% { transform: translateY(-2px) rotate(3deg) scale(1.04); }\n  40% { transform: translateY(1px) rotate(-4deg) scale(1.06); }\n  60% { transform: translateY(-1px) rotate(3.5deg) scale(1.05); }\n  80% { transform: translateY(1px) rotate(-2deg) scale(1.02); }\n  100% { transform: translateY(0) rotate(0deg) scale(0.9); opacity: 0; }\n}\n\n@keyframes fadeOut {\n  to { opacity: 0; }\n}\n\n@keyframes chipIn {\n  from {\n    opacity: 0;\n    transform: translateY(10px) rotate(0deg) scale(0.88);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) rotate(var(--tilt, 0deg)) scale(1);\n  }\n}\n\n@keyframes iceBob {\n  0%, 100% { transform: translateY(0) rotate(-2.4deg); }\n  50% { transform: translateY(-9px) rotate(2.4deg); }\n}\n\n@keyframes glowPulse {\n  0%, 100% { transform: scale(1); opacity: 0.85; }\n  50% { transform: scale(1.12); opacity: 1; }\n}\n\n@media (max-width: 600px) {\n  .landing {\n    min-height: calc(100dvh - 3.6rem);\n    padding: 1.5rem 1.25rem 2rem;\n  }\n\n  .landingHero .logo {\n    height: 6.2rem;\n  }\n\n  .landingHero h1 {\n    font-size: 2.45rem;\n  }\n\n  .landingLogoWrap::before {\n    width: 9rem;\n    height: 9rem;\n  }\n\n  .landingRounds {\n    display: grid;\n    grid-template-columns: auto auto;\n    justify-content: center;\n  }\n\n  .landingActions {\n    padding: 1.25rem;\n  }\n\n  .landingDecor .spark.s3,\n  .landingDecor .spark.s5,\n  .landingDecor .flake.f3 {\n    display: none;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .landingHero,\n  .landingHero h1,\n  .landingTagline,\n  .landingRounds li,\n  .landingActions,\n  .landingHero .logo,\n  .landingLogoWrap::before,\n  .landing.leaving .landingHero,\n  .landing.leaving .landingActions,\n  .landing.leaving .landingHero .logo,\n  .landing.leaving .landingDecor {\n    animation: none;\n  }\n\n  .landingRounds li {\n    transform: rotate(var(--tilt, 0deg));\n  }\n\n  .landing.leaving .landingHero,\n  .landing.leaving .landingActions {\n    opacity: 0.4;\n    transition: opacity 0.2s;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
